import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MenuItem = ({ item, sectionLabel, activeMenu, navigateToMenuItem }) => {
	const [isActive, setIsActive] = useState();
	const navigate = useNavigate();

	useEffect(() => {
		setIsActive(activeMenu === item.IDENTIFIER);
	}, [activeMenu]);

	useEffect(() => {
		if (isActive) {
			navigateToItem();
		}
	}, [isActive]);

	const navigateToItem = () => {
		navigate(item.PATH);
		navigateToMenuItem({
			menu: {
				headerSectionLabel: sectionLabel,
				headerTextIdentifier: item.LABEL,
				menuIdentifier: item.IDENTIFIER,
				menuItems: item.ITEMS
			}
		});
	};

	const renderBadge = () => {
		if (item.BADGE === 'dot') {
			return <span className="sidebar-item-dot" />;
		}

		if (typeof item.BADGE === 'number') {
			return <span className="sidebar-item-badge">{item.BADGE.toLocaleString('en-US')}</span>;
		}

		return null;
	};

	return (
		<li 
			className={ `sidebar-item qa-${item.IDENTIFIER} ${isActive ? 'sidebar-item--active' : ''}`}
			onClick={navigateToItem}
		>
			<span>{item.LABEL}</span>
			{renderBadge()}
		</li>
	);
};

export default MenuItem;
